import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';

import type { GetPartnerProductsParams } from '@apis/product';
import { getPartnerProductsCount } from '@apis/product';

import { dropEmptyValues } from '../../utils/common';

/**
 * Partner product count query.
 *
 * Key policy:
 * - queryKey MUST include cleaned search params
 *   so that total count updates immediately when filters change.
 */
export const usePartnerProductCount = (searchParam: GetPartnerProductsParams) => {
  const cleanedSearchParam = useMemo(
    () =>
      dropEmptyValues(searchParam, [
        'productCode',
        'productName',
        'countryId',
      ]),
    [searchParam],
  );

  return useQuery<number, Error>({
    queryKey: ['partnerProductsCount', cleanedSearchParam],
    queryFn: () => getPartnerProductsCount(cleanedSearchParam),
  });
};
